import { useState, useEffect } from "react";
import useAuth from "./useAuth";
import { STOCKITEMS_BASE_URL } from "../config";
import API from "../API";

const initialState = {
  stockitems: [],
  page: 0,
  total_pages: 0,
  total_results: 0,
};

export const useStockitemsListFetch = () => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [searchValue, setSearchValue] = useState("");
  const [includeInactive, setIncludeInactive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true); // ✅ Prevent double fetching

  const accessToken = auth.auth.accessToken;

  const fetchStockitemsList = async (page, searchValue, reset = false) => {
    if (!hasMore && !reset) return; // Stop fetching if no more pages

    try {
      setLoading(true);
      setError(false);

      console.log(reset)

      const data = await API.fetchStockitems(searchValue, page, includeInactive, "", accessToken);
      console.log(data.stockitems)
      const newStockitems = await Promise.all(
        data.stockitems.map(async (stockitem) => {
          let imageUrl = "";
          if (stockitem.image_path) {
            try {
              const imageResponse = await fetch(
                `${STOCKITEMS_BASE_URL}${stockitem.image_path}`,
                { headers: { Authorization: `Bearer ${accessToken}` } }
              );

              if (imageResponse.ok) {
                const blob = await imageResponse.blob();
                imageUrl = URL.createObjectURL(blob);
              }
            } catch (imageError) {
              console.error(`Error fetching image for ${stockitem.desc}:`, imageError);
            }
          }
          return { ...stockitem, imageUrl };
        })
      );

      setState((prev) => ({
        ...prev,
        stockitems: reset ? newStockitems : [...prev.stockitems, ...newStockitems], // ✅ Only reset on filter/search change
        page: page + 1,
        total_pages: data.total_pages,
        total_results: data.total_results,
      }));

      setHasMore(newStockitems.length > 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching stock items:", error);
      setError(true);
    }
  };

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      fetchStockitemsList(1, searchValue, true);
    }
  }, [firstLoad]); // ✅ Runs only once when the component mounts

  useEffect(() => {
    fetchStockitemsList(1, searchValue, true); // ✅ Fetch when search/filter changes
  }, [searchValue, includeInactive]);

  return { state, loading, error,searchValue, setSearchValue, setIncludeInactive, fetchStockitemsList };
};
